import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import GenericModal from '../../GenericModal'
import { connect } from 'react-redux'
import classNames from 'classnames';
import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'


const Content = styled.div`

  padding: 16px 20px 17px 20px;

  h3 {
    font-family: Lato-Regular;
    font-size: 12px;
    font-weight: normal;

    color: #666666;
    line-height: 16px;
    margin: 0px;
    padding: 0px;
  }

  p {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #2B2B2B;
    line-height: 22px;
    margin: 0px;
    padding: 0px;
    margin-top: 6px;
  }

  .current-method {
    color: #666666;
    background: #EDEDED;
    padding: 11px 16px;
    margin-top: 9px;
    display: block;
  }

  > button {
    height: 43px;
    width: 100%;
    margin-top: 15px;
  }

  > div {

    a {
      font-family: Lato-Regular;
      font-size: 14px;
      color: #1D71BB;
      line-height: 16px;
      text-decoration: none;
      margin-top: 7px;
      display: block;
    }
  }

  .disableClick{
      pointer-events: none;
      color: #BBBBBB;
  }
`

export class USFedRateDialog extends Component {

  onChangeTaxPayment = (callback) => {
    this.props.onChangeTaxPayment()
  }

  onChangeTaxPaymentBroker = () => {
    var brokerUrl = employeeService.getEmployeeBrokerUrl(this.props.employee)

    if(this.props.employee.broker && brokerUrl && this.props.employee.broker !== '') {
      var win = window.open(brokerUrl, '_blank');
      win.focus();
      this.props.onCloseDialog()
    }
  }

  render() {
    
    if (!this.props.visible) {
      return null;
    }
    const { t, employee, awardIdSelected, calendarYear, vest } = this.props;
    const disabled = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_DISABLE) ? true : false

    let methods = ''

    if (vest) {
      methods = t(`TaxTreatment.${vest.tax_election.code}`)
    } else {
      methods = employeeService.getPaymentMethods(employee.awards, awardIdSelected, calendarYear)
        .map(taxElectionCode => t(`TaxTreatment.${taxElectionCode}`))
        .join(', ')
    }

    let taxElectionsEmail = t('USFedRateDialog.TaxElectionEmailNoAPS')
    if (employeeService.isZooxEmployee(employee)){
      taxElectionsEmail = t('USFedRateDialog.TaxElectionEmailZoox')
    }

    return (
      <GenericModal
        title={t('USFedRateDialog.Title')}
        visible={this.props.visible}
        onCloseDialog={this.props.onCloseDialog}
        width={380}
        className="tax-elections"
      >
        <Content>
            <div>
              <h3>{t('USFedRateDialog.USFederalTaxRate')}</h3>
              { !disabled &&
                <div>
                  <p>{t('USFedRateDialog.IfYouNeed')}</p>
                  <a aria-haspopup={true} onClick={this.onChangeTaxPayment} href="#/" >{t('USFedRateDialog.ChangeUSFederalTaxRate')}</a>
                </div>
              }

              { !employeeService.isWholeFoodsEmployee(employee) && !employeeService.isZooxEmployee(employee) &&
                <span>
                  <p dangerouslySetInnerHTML={{ __html: t('USFedRateDialog.PreclearanceToolText') }}></p>
                  <a target="_blank" href={process.env.REACT_APP_PRECLEAR} >{t('USFedRateDialog.PreclearanceToolLink')}</a>
                </span>
              }

              { (employeeService.isWholeFoodsEmployee(employee) || employeeService.isZooxEmployee(employee)) &&
                  <p dangerouslySetInnerHTML={{ __html: t('USFedRateDialog.PreclearanceWholeFoodsText') }}></p>
              }

            </div>

        </Content>
      </GenericModal>
    )
  }
}

const mapState = state => ({
  employee: state.employee
})

export default connect(mapState)(withTranslation('translations')(USFedRateDialog))

